import ActivityStatusOption from "@mapmycustomers/shared/enum/activity/ActivityStatusOption";
import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import doesContainFilterModel from "../filters/doesContainFilterModel";
import { isSimpleCondition } from "../viewModel/assert";

import mapActivityStatusOptionToFilter from "./mapActivityStatusOptionToFilter";

export const getActivityStatusOptionByFilter = (filter: FilterModel): ActivityStatusOption => {
  const incomplete =
    filter?.completed &&
    isSimpleCondition(filter.completed) &&
    (filter.completed.operator === FilterOperator.IS_FALSE || filter.completed.value === false);

  if (incomplete && filter?.startAt?.operator === FilterOperator.INTERVAL_BEFORE) {
    return ActivityStatusOption.OVERDUE;
  }
  if (incomplete && filter?.startAt?.operator === FilterOperator.INTERVAL_AFTER) {
    return ActivityStatusOption.UPCOMING;
  }
  const result = [
    ActivityStatusOption.INCOMPLETE,
    ActivityStatusOption.COMPLETED,
    ActivityStatusOption.NOT_SCHEDULED,
  ].reduce<ActivityStatusOption | undefined>(
    (result, status) =>
      result ??
      (doesContainFilterModel(mapActivityStatusOptionToFilter[status], filter)
        ? status
        : undefined),
    undefined
  );

  return result ?? ActivityStatusOption.ALL;
};

export default getActivityStatusOptionByFilter;
